import React, {useEffect, useState} from 'react';
import {ForumInterface} from "../../forums";
import Modal from "../../../../../components/modal/modal";
import RegistrationForm from "../forumsRegistrationForm/registrationForm";
import {useAuth} from "../../../../../components/authProvider/authProvider";
import ModalLogin from "../../../../../components/modalLogin/modalLogin";
import {baseUrl} from "../../../../../constants/constants";
import {Link, useParams, useSearchParams} from "react-router-dom";


const Forum:React.FC<ForumInterface> = ({id,
                                            name,
                                            description,
                                            supplement,
                                            start_date_training,
                                            end_date_training,
                                            image_url, is_active,
                                            forum_visit_format,
                                            forum_location,
                                            educational_organization_id,
                                            results_link
}) => {
    const [showModal, setShowModal] = useState(false)
    const [showLoginModal, setShowLoginModal] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const isAuth = useAuth()

    const [query] = useSearchParams();

    useEffect(() => {
        const forumId = query.get('forum-reg');
        if(!forumId) return;

        if(Number(forumId) !== id) return;

        if(!isAuth?.authState.isAuth) {
            setShowLoginModal(true);
            return;
        }

        setShowModal(true);
    }, [query])

    const closeModal = () =>{
        setShowModal(false);
        if(Number(query.get('forum-reg')) === id) {
            window.location.search = '';
        }
    }

    const forumStartDate = new Date(start_date_training).toLocaleString('ru', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

    const forumStartDateShort = new Date(start_date_training).toLocaleString('ru', {
        // month: 'long',
        day: 'numeric',
        // year: 'numeric'
    });

    const forumEndDate = new Date(end_date_training).toLocaleString('ru', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

    const openPopupWithAuth = () => {
        if (isAuth?.authState?.isAuth){
            setShowModal(true)
        } else {
            setShowLoginModal(true)
        }
    }

    const endDate = new Date(end_date_training)

    useEffect(() => {
        let now = new Date()
        if(now > endDate){
            setDisabled(true);
        } else setDisabled(false);

        if(is_active){
            setDisabled(false)
        } else setDisabled(true)
    }, []);


    return (
            <section className="forum">
                <div className="forum-img">
                    <img
                        src={`${baseUrl}${image_url}`}
                        alt="Обложка мероприятия"
                        className='forum-img__img'
                    />
                </div>
                <div className="forum-description">
                    <div className="forum-description__text">
                        <h2 className="forum-description__text-h2">
                            {name}
                        </h2>
                        <p className="forum-description__text-p">
                            {description}
                        </p>
                        <p className="forum-description__text-p">
                            {supplement}
                        </p>
                    </div>
                    <div className="forum-description__button">
                        {is_active ? (
                            <button
                                onClick={openPopupWithAuth}
                                className={'button forum-btn'}
                            >
                                Регистрация
                            </button>
                        ) : results_link !== '' ? (
                            <Link to={results_link} target="_blank" rel="noopener noreferrer">
                                <button className="button forum-btn">
                                    Итоги форума
                                </button>
                            </Link>
                        ) : null}


                        {showModal &&
                            <Modal
                                active={showModal}
                                title={`Регистрация на ${name}`}
                                сlose={closeModal}
                            >
                            <RegistrationForm
                                    id={id}
                                    close={closeModal}
                                    forum_visit_format={forum_visit_format}
                                    educational_organization_id={educational_organization_id}
                                />
                            </Modal>
                        }
                        {showLoginModal &&
                            <ModalLogin
                                saveData={{
                                    key: 'urlForum',
                                    value: `/meropriyatiya?forum-reg=${id}`
                                }}
                                showLoginModal={showLoginModal}
                                setShowLoginModal={(v, isUserAuth) => {
                                    setShowLoginModal(v);
                                    if(isUserAuth) {
                                        setShowModal(true);
                                    }
                                }}
                            />
                        }
                        <div className="forum-description__button-date">
                            <p className="forum-description__button-date-p">{forumStartDateShort} - {forumEndDate}</p>
                            <p className="forum-description__button-date-p">{forum_location}</p>
                        </div>

                    </div>
                </div>
            </section>
    );
};

export default Forum;

// <RegistrationForm id={id}/>
//